import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import ouiStyle from '@goldwasserexchange/oui-style';

export const SanityStrong = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  return (
    <ouiDom.TextSnippet.TextSnippet
      color={ouiStyle.Constants.Colors.inherit}
      fontSize="inherit"
      fontStyle="inherit"
      textDecoration="inherit"
      fontWeight={ouiStyle.Constants.FontWeightProp.intermediary}
    >
      {children}
    </ouiDom.TextSnippet.TextSnippet>
  );
};
